import Measure from './measure';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import type MealItemIngredient from './meal-item-ingredient';
import type ServingTool from './serving-tool';

@JsonApiResource({
  type: 'meal-item',
})
export default class MealItem extends BaseEntity {
  @JsonApiProperty({ type: 'string' }) name: string;
  @JsonApiProperty({ resolver: Number }) servingSize: number;
  @JsonApiProperty({ resolver: Number }) size: number;

  @JsonApiRelationship('meal-item-ingredient') mealItemIngredients: MealItemIngredient[];
  @JsonApiRelationship('measure') measure: Measure;
  @JsonApiRelationship('measure') servingMeasure: Measure;
  @JsonApiRelationship('serving-tool') servingTool: ServingTool | null;

  constructor(
    id?: MealItem['id'],
    name: MealItem['name'] = '...',
    servingMeasure: MealItem['servingMeasure'] = new Measure('1'),
    measure: MealItem['measure'] = new Measure('1'),
    servingSize: MealItem['servingSize'] = 1.0,
    mealItemIngredients: MealItem['mealItemIngredients'] = [],
    servingTool: MealItem['servingTool'] = null,
    size: MealItem['size'] = 1.0
  ) {
    super();
    this.id = id;
    this.name = name;
    this.servingMeasure = servingMeasure;
    this.measure = measure;
    this.servingSize = servingSize;
    this.mealItemIngredients = mealItemIngredients;
    this.servingTool = servingTool;
    this.size = size;
  }
}
